<template>
  <div class="result" v-if="message !== null">
    <Header :image="message.image" :index="null" :progress_questions="questions" />
    <section>
      <h1>{{ message.headline }}</h1>
            <p v-for="(text, index) in message.paragraphs" v-html="text" v-bind:key="index">
            </p>
            <Button v-if="nextStep" :colors="settings.button_colors" key="nextStep" :action="nextStepAction" :text="this.action.text" :href="this.action.href" :type="this.action.type" @nextStep="next" @external="external" />
            <Button v-for="(button, index) in message.buttons" :colors="settings.button_colors" v-bind:key="index" :action="index" :text="button" @restart="update" />
    </section>
  </div>
</template>

<script>
import Button from './Button.vue'
import Header from './Header.vue'
// @ToDo: add logic differencing success or fail
export default {
  name: 'Result',
  components: {
    Button,Header
  },
  computed: {
    nextStep(){
      if(this.action.type != 'hidden' && this.message.action){
        return true
      }
      else return false
    },
    nextStepAction(){
      if(this.action.type == "next") return "nextStep"
      else return this.action.type;
    },
    renderActionButton(){
      return this.render_action;
    }
  },
  props: ['settings','correct','messages','questions','action'],
  mounted: function(){
    this.setMessage();
  },
  data: function(){
    return{
      message: null,
      render_action : null
    }
  },
  methods: {
    update(){
      this.$emit('restart')
    },
    next(){
      this.$emit('nextStep')
    },
    external(){
      this.$emit('external')
    },
    setMessage(){
      if( this.correct.length >= this.settings.necessary_answers ){
        this.message = this.messages.success;
        this.render_action = true;
      }
      else{
        this.message = this.messages.fail;
        this.render_action = false;
      }
    }
  }
}
</script>
